import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <Wrapper>
      <p>&copy; {new Date().getFullYear()} EYE20 GROUP. All rights reserved.</p>
    </Wrapper>
  );
};

const Wrapper = styled.footer`
  background: #003366;
  color: white;
  text-align: center;
  padding: 1.5rem 1rem;
  font-size: 0.9rem;
`;

export default Footer;
